export default __webpack_public_path__ + "media/images/furnished_apartments/section_right_img1-43a9746003f0033f62b75310b49cef28.png";